jQuery(document).ready(function ($) {

    $('.sliders_1 .slider').slick({
        autoplay: true,
        dots: true,
        infinite: true,
        speed: 1500,
        autoplaySpeed: 5000,
        fade: true,
        cssEase: 'linear',
        arrows: true
        // prevArrow: '<button><i class="icon-read_more_round_left"></button></i>',
        // nextArrow: '<button><i class="icon-read_more_round"></i></button>',
    });

});
